export { StickyColumn, type StickyColumnProps } from './StickyColumn';
